import apiClient from '../../core/apiClient';

export const predictiveService = {
  getHealthHeatmap: async () => {
    const response = await apiClient.get('/api/admin/risk/dashboard');
    return response.data;
  }
};
